var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconVendor = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.677,
    height: 12.993,
    viewBox: "0 0 13.677 12.993",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_work_24px",
    d: "M14.309,4.735H11.574V3.368A1.363,1.363,0,0,0,10.206,2H7.471A1.363,1.363,0,0,0,6.1,3.368V4.735H3.368A1.357,1.357,0,0,0,2.007,6.1L2,13.625a1.363,1.363,0,0,0,1.368,1.368H14.309a1.363,1.363,0,0,0,1.368-1.368V6.1A1.363,1.363,0,0,0,14.309,4.735Zm-4.1,0H7.471V3.368h2.735Z",
    transform: "translate(-2 -2)",
    fill: "#727272"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconVendor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-vendor.ee780a155077983d20fa98954a077292.svg";